<app-header></app-header>

<div class="sdps-grid-container sdps-wrap sdps-m-around_none" *ngIf="authSer.userAuthentication | async">
  <div class="col-full sdps-p-around_none">
    <router-outlet></router-outlet>
  </div>
</div>

<app-footer *ngIf="authSer.userAuthentication | async"></app-footer>
